import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  max-width: 800px;
  margin: 0 auto;

  .mark-down {
    color: #ccc;
  }

  margin-bottom: 100px;
`;
